var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEyeDetail = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9823 9.99993C12.9823 11.6499 11.649 12.9833 9.99896 12.9833C8.34896 12.9833 7.01562 11.6499 7.01562 9.99993C7.01562 8.34993 8.34896 7.0166 9.99896 7.0166C11.649 7.0166 12.9823 8.34993 12.9823 9.99993Z",
    stroke: "#333335",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99792 16.8913C12.9396 16.8913 15.6813 15.1579 17.5896 12.1579C18.3396 10.9829 18.3396 9.00794 17.5896 7.83294C15.6813 4.83294 12.9396 3.09961 9.99792 3.09961C7.05625 3.09961 4.31458 4.83294 2.40625 7.83294C1.65625 9.00794 1.65625 10.9829 2.40625 12.1579C4.31458 15.1579 7.05625 16.8913 9.99792 16.8913Z",
    stroke: "#333335",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEyeDetail, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/eye-detail.e3741fa0.svg";
export { ForwardRef as ReactComponent };